/**
 * Open Modal javascript trigger
 */
function openModal(modal, opener){
  if(modal && typeof modal.show === 'function') {
    try {
      modal.show(opener);
    } catch (err) {
      console.error('Modal open error:', err);
    }
  }
}

/**
* background Overlay
*/
class SiteOverlay extends HTMLElement{
  constructor() {
    super();
    this.overlayElement = Utility.DomSelector.byId('site-overlay');
    this.bindEvents();
  }

  /**
   * bind Click and Touchend event to this custom component
   */
  bindEvents(){
    this.addEventListener('click', this.onClick.bind(this));
    this.addEventListener('touchend', this.onClick.bind(this));
  }

  /**
   * Click event of Site overlay
   */
  onClick(){
    SiteOverlay.hideOverlay();
  }

  /**
   * Show Overlay
   * @param {string} drawerClass - Optional class to add based on drawer type
   * @returns {boolean} Returns true if overlay was shown, false if already visible
   */
   static showOverlay(drawerClass = null){
    const overlay = Utility.DomSelector.byId('site-overlay');
    if (overlay.classList.contains('overlay--body')) {
      return false; // Already visible
    }
    
    Utility.CSS.add(overlay, 'overlay--body');
    overlay.setAttribute('aria-hidden', 'true');
    Utility.CSS.add(document.body, 'scroll-fixed');
    
    // Add drawer-specific class if provided
    if (drawerClass) {
      Utility.CSS.add(overlay, drawerClass);
    }
    
    // Make background content inert (prevents focus and interaction)
    // const mainContent = Utility.DomSelector.$('main');
    // const header = Utility.DomSelector.$('header');
    // if (mainContent) mainContent.setAttribute('inert', '');
    // if (header) header.setAttribute('inert', '');
    
    return true; // Successfully shown
  }

  /**
   * Hide overlay
   * @returns {boolean} Returns true if overlay was hidden, false if already hidden
   */
  static hideOverlay(){
    const overlay = Utility.DomSelector.byId('site-overlay');
    if (!overlay.classList.contains('overlay--body')) {
      return false; // Already hidden
    }
    
    const openDrawers = Utility.DomSelector.$$('custom-drawer.open');
    openDrawers.forEach(drawer => {
      drawer.closeDrawer();
    });
    
    // Remove all drawer-specific overlay classes (keep only overlay--body and scroll-fixed)
    const overlayClasses = Array.from(overlay.classList).filter(cls => cls !== 'overlay--body' && cls !== 'scroll-fixed');
    overlayClasses.forEach(cls => Utility.CSS.remove(overlay, cls));
    
    Utility.CSS.remove(overlay, 'overlay--body');
    Utility.CSS.remove(document.body, 'scroll-fixed');
    
    // Remove inert from background content
    // const mainContent = Utility.DomSelector.$('main');
    // const header = Utility.DomSelector.$('header');
    // if (mainContent) mainContent.removeAttribute('inert');
    // if (header) header.removeAttribute('inert');
    
    return true; // Successfully hidden
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick.bind(this));
    this.removeEventListener('touchend', this.onClick.bind(this));
  }
}
if (!customElements.get('site-overlay')) {
  customElements.define("site-overlay", SiteOverlay);
}

/**
* Custom Video
*/
class CustomVideo extends HTMLElement {
  constructor() {
    super();

    this.type = this.dataset.videoType;
    this.videoURL = (this.dataset.videoId || '').trim();
    this.placementType = this.dataset.placement;
    this.videoStatus = 'empty';
    
    this.container = this.closest('.custom-video-container');
    this.videoModal = document.getElementById('PopupModal-video');
    this.contentSection = Utility.DomSelector.$('.content-section', this);
    this.videoSection = Utility.DomSelector.$('.video-section', this);
    if(this.placementType == 'popup') this.videoSection = Utility.DomSelector.$('.video-container', this.videoModal);
    this.triggerVideo = Utility.DomSelector.$('[data-trigger-video]', this) || Utility.DomSelector.$('[data-trigger-video]', this.container);
    this.muteBtnWrap = Utility.DomSelector.$('.video-mute-btn-wrap', this);
    this.muteToggle = Utility.DomSelector.$('[data-video-mute-toggle]', this);
    this.modalMuteBtnWrap = this.videoModal
      ? Utility.DomSelector.$('[data-modal-video-mute-wrap]', this.videoModal)
      : null;
    this.modalMuteToggle = this.modalMuteBtnWrap
      ? Utility.DomSelector.$('[data-video-mute-toggle]', this.modalMuteBtnWrap)
      : null;

    this.boundToggleView = this.toggleView.bind(this);
    this.boundMuteToggle = this.onMuteToggle.bind(this);
    this._volumeBound = null;
    this._muteListenerVideo = null;
    this._youtubeMutedState = undefined;
    this._suppressModalReset = false;
    this._isBuilding = false;
  }

  connectedCallback() {
    this.bindEvents();
  }

  disconnectedCallback() {
    if (this.triggerVideo && this.boundToggleView) {
      this.triggerVideo.removeEventListener('click', this.boundToggleView);
    }
    if (this.muteToggle && this.boundMuteToggle) {
      this.muteToggle.removeEventListener('click', this.boundMuteToggle);
    }
    if (CustomVideo._activePopupHost === this) {
      this._deactivateModalMute();
    }
    this._detachMuteVolumeListener();
  }

  /**
   * Binding events on the video button
   */
  bindEvents(){
    if(Utility.DomSelector.exists('[data-poster-video]', this)) this.managePosterVideos();
    if(this.triggerVideo) this.triggerVideo.addEventListener('click', this.boundToggleView);
    if (this.dataset.muteButton === 'true' && this.muteToggle && this.placementType !== 'popup') {
      this.muteToggle.addEventListener('click', this.boundMuteToggle);
    }

    // Autoplay on init if placement is grid and autoplay is true and not in a swiper slide. Slider autoplay is managed by the manageSwiperSlides function to support slide init with deferred js loading.
    if(this.dataset.placement == 'grid' && this.dataset.autoplay == 'true' && this._canBuildVideo()) this.autoplayOnInit();
    // if(this.dataset.placement == 'grid' && this.dataset.autoplay == 'true' && !this.closest('swiper-slide')) this.autoplayOnInit();
    // if(this.placementType == 'grid') this.addEventListener('focusout', this.focusOut.bind(this));
  }

  /**
   * Focus Out Event to close drawer
   *
   * @param {event} Event instance
   */
  focusOut(_event){
    if(this.container?.classList.contains('playing--video')) this.toggleView();
  }

  _ensureVideoSection() {
    if (this.placementType === 'popup') {
      if (!this.videoModal) this.videoModal = document.getElementById('PopupModal-video');
      if (this.videoModal) {
        this.videoSection = Utility.DomSelector.$('.video-container', this.videoModal);
      }
    } else if (!this.videoSection) {
      this.videoSection = Utility.DomSelector.$('.video-section', this);
    }
    return Boolean(this.videoSection);
  }

  _getYoutubeVideoId(url) {
    if (!url) return '';

    try {
      if (url.includes('youtu.be/')) {
        return url.split('youtu.be/')[1].split(/[?&]/)[0];
      }
      const parsed = new URL(url, window.location.origin);
      if (parsed.hostname.includes('youtube.com')) {
        return parsed.searchParams.get('v') || parsed.pathname.split('/').filter(Boolean).pop() || '';
      }
    } catch (_err) {
      const legacyId = url.replace('https://www.youtube.com/watch?v=', '').split('&')[0];
      if (legacyId) return legacyId;
    }

    return '';
  }

  _canBuildVideo() {
    if (!this.videoURL) return false;
    if (this.type === 'local') return true;
    if (this.type === 'youtube') return Boolean(this._getYoutubeVideoId(this.videoURL));
    return false;
  }

  _getPlayerElement() {
    if (!this.videoSection) return null;
    return Utility.DomSelector.$('video', this.videoSection) || Utility.DomSelector.$('iframe', this.videoSection);
  }

  _playerMatchesCurrentVideo(player) {
    if (!player || !this.videoURL) return false;

    if (this.type === 'local') {
      const src = player.currentSrc || player.src || '';
      return src === this.videoURL || src.includes(this.videoURL) || this.videoURL.includes(src);
    }

    if (this.type === 'youtube') {
      const videoId = this.videoURL.replace('https://www.youtube.com/watch?v=', '').split('&')[0];
      return Boolean(player.src && player.src.includes(videoId));
    }

    return false;
  }

  _clearPlayer() {
    if (this.videoSection) this.videoSection.innerHTML = '';
    this.videoStatus = 'empty';
  }

  _getPosterVideo() {
    return Utility.DomSelector.$('[data-poster-video]', this);
  }

  _pausePosterVideo() {
    const posterVideo = this._getPosterVideo();
    if (posterVideo && !posterVideo.paused) {
      posterVideo.pause();
    }
  }

  _resumePosterVideo() {
    const posterVideo = this._getPosterVideo();
    if (posterVideo && posterVideo.paused) {
      posterVideo.play().catch(err => console.warn('Poster video play blocked:', err));
    }
  }

  /**
   * Close other playing videos via toggleView (pause, reset mute state)
   */
  _closeOtherPlayingVideos() {
    document.querySelectorAll('custom-video').forEach((host) => {
      if (host === this) return;

      const container = host.closest('.custom-video-container');
      if (!container?.classList.contains('playing--video')) return;

      host.toggleView();
    });
  }

  /**
   * Toggle of video modal
   * @returns {CustomVideo} Returns this for method chaining
   */
  toggleView(event){
    if(event) event.preventDefault();
    if (!this.container || !this._canBuildVideo()) return this;
    const isOpen = this.container.classList.contains('playing--video');
    if (isOpen) {
      this.hideContent();
    } else {
      if (event) this._closeOtherPlayingVideos();
      this.showContent();
    }
    return this; // Enable method chaining
  }

  /**
   * Show panel content
   * @returns {CustomVideo} Returns this for method chaining
   */
  showContent() {
    if (!this.container || !this._canBuildVideo()) return this;
    if (!this._ensureVideoSection()) return this;

    let existingPlayer = this._getPlayerElement();
    if (existingPlayer && !this._playerMatchesCurrentVideo(existingPlayer)) {
      this._clearPlayer();
      existingPlayer = null;
    }

    if (existingPlayer) {
      Utility.CSS.add(this.container, 'playing--video');
      if (this.placementType === 'popup' && this.videoModal && !this.videoModal.isOpen) {
        openModal(this.videoModal, this.triggerVideo);
      }
      if (this.videoSection) {
        this.videoSection.removeAttribute('inert');
        this.videoSection.setAttribute('aria-hidden', 'false');
      }
      this._pausePosterVideo();
      this._playVideo(existingPlayer);
      if (this.dataset.muteButton === 'true') {
        this._activateModalMute();
      } else if (this.placementType === 'popup') {
        this._deactivateModalMute();
      }
      this._initMuteControl(existingPlayer);
      this._syncPlayPauseButtonState(true);
      return this;
    }

    if (this._isBuilding) return this;
    this._isBuilding = true;

    const videoElement = this._buildVideo();
    if (!videoElement) {
      this._isBuilding = false;
      return this;
    }

    videoElement.id = 'custom-video' + Math.floor((Math.random() * 100) + 1);

    this._clearPlayer();
    this.videoSection.appendChild(videoElement);
    this.videoStatus = 'loaded';

    setTimeout(() => {
      this._isBuilding = false;
      Utility.CSS.add(this.container, 'playing--video');
      if (this.placementType === 'popup') openModal(this.videoModal, this.triggerVideo);
      this.videoSection.removeAttribute('inert');
      this.videoSection.setAttribute('aria-hidden', 'false');
      this._pausePosterVideo();
      if(this.dataset.controls === 'true') this.pauseOnVisibilityChange(videoElement);
      if (this.dataset.muteButton === 'true') {
        this._activateModalMute();
      } else if (this.placementType === 'popup') {
        this._deactivateModalMute();
      }
      this._initMuteControl(this._getPlayerElement());
      this._syncPlayPauseButtonState(true);
    }, 500);

    return this;
  }

  _getMuteToggle() {
    if (this.dataset.muteButton !== 'true') return null;
    if (this.placementType === 'popup' && this.modalMuteToggle) return this.modalMuteToggle;
    return this.muteToggle;
  }

  _activateModalMute() {
    if (this.placementType !== 'popup' || this.dataset.muteButton !== 'true' || !this.modalMuteBtnWrap || !this.modalMuteToggle) return;

    if (CustomVideo._activePopupHost && CustomVideo._activePopupHost !== this) {
      CustomVideo._activePopupHost._deactivateModalMute();
    }
    CustomVideo._activePopupHost = this;

    this.modalMuteToggle.removeEventListener('click', this.boundMuteToggle);
    this.modalMuteToggle.addEventListener('click', this.boundMuteToggle);
    Utility.CSS.add(this.modalMuteBtnWrap, 'is-active');
    this.modalMuteBtnWrap.setAttribute('aria-hidden', 'false');
    this.modalMuteBtnWrap.removeAttribute('inert');
  }

  _deactivateModalMute() {
    if (!this.modalMuteToggle) return;

    this.modalMuteToggle.removeEventListener('click', this.boundMuteToggle);
    if (this.modalMuteBtnWrap) {
      Utility.CSS.remove(this.modalMuteBtnWrap, 'is-active');
      this.modalMuteBtnWrap.setAttribute('aria-hidden', 'true');
      this.modalMuteBtnWrap.setAttribute('inert', '');
    }
    if (CustomVideo._activePopupHost === this) CustomVideo._activePopupHost = null;
  }

  _resetAfterModalClose() {
    if (!this.container) return;
    this._isBuilding = false;
    Utility.CSS.remove(this.container, 'playing--video');
    this._deactivateModalMute();
    this._clearPlayer();
    if (this.videoSection) {
      this.videoSection.setAttribute('inert', '');
      this.videoSection.setAttribute('aria-hidden', 'true');
    }
    this._resumePosterVideo();
    this._detachMuteVolumeListener();
    this._youtubeMutedState = undefined;
    this._syncPlayPauseButtonState(false);
  }

  /**
   * Hide panel content
   * @returns {CustomVideo} Returns this for method chaining
   */
  hideContent() {
    if (!this.container) return this;
    this._isBuilding = false;
    const videoElement = this._getPlayerElement();
    if (videoElement) {
      this._pauseVideo(videoElement);
    }

    if (this.placementType === 'popup' && this.videoModal?.isOpen) {
      this._suppressModalReset = true;
      this.videoModal.hide();
      this._suppressModalReset = false;
    }

    Utility.CSS.remove(this.container, 'playing--video');
    this._deactivateModalMute();
    if (this.videoSection) {
      this.videoSection.setAttribute('inert', '');
      this.videoSection.setAttribute('aria-hidden', 'true');
    }
    if (this.placementType === 'popup') {
      this._clearPlayer();
    }
    this._resumePosterVideo();
    this._detachMuteVolumeListener();
    this._youtubeMutedState = undefined;
    this._syncPlayPauseButtonState(false);
    return this; // Enable method chaining
  }

  _syncPlayPauseButtonState(isPlaying) {
    if (!this.triggerVideo) return;

    const labelPlay = this.triggerVideo.dataset.ariaPlay || this.triggerVideo.getAttribute('aria-label') || '';
    const labelPause = this.triggerVideo.dataset.ariaPause || labelPlay;
    if (!labelPlay && !labelPause) return;
    this.triggerVideo.setAttribute('aria-label', isPlaying ? labelPause : labelPlay);
  }

  /**
   * @param {HTMLVideoElement|HTMLIFrameElement|null} videoElement
   */
  _initMuteControl(videoElement) {
    if (this.dataset.muteButton !== 'true' || !this._getMuteToggle() || !videoElement) return;

    this._detachMuteVolumeListener();
    if (this.type === 'youtube') {
      this._youtubeMutedState = this.dataset.muted === 'true';
    }
    this._syncMuteButtonState(videoElement);

    if (this.type === 'local') {
      this._volumeBound = () => this._syncMuteButtonState(videoElement);
      videoElement.addEventListener('volumechange', this._volumeBound);
      this._muteListenerVideo = videoElement;
    }
  }

  _detachMuteVolumeListener() {
    if (this._muteListenerVideo && this._volumeBound) {
      this._muteListenerVideo.removeEventListener('volumechange', this._volumeBound);
    }
    this._muteListenerVideo = null;
    this._volumeBound = null;
  }

  /**
   * @param {HTMLVideoElement|HTMLIFrameElement} videoElement
   */
  _syncMuteButtonState(videoElement) {
    const muteToggle = this._getMuteToggle();
    if (this.dataset.muteButton !== 'true' || !muteToggle) return;

    const muted = this.type === 'local'
      ? Boolean(videoElement.muted)
      : Boolean(this._youtubeMutedState);

    const labelMuted = muteToggle.dataset.ariaMuted || '';
    const labelUnmuted = muteToggle.dataset.ariaUnmuted || '';
    muteToggle.setAttribute('aria-label', muted ? labelMuted : labelUnmuted);

    muteToggle.classList.toggle('is-muted', muted);
  }

  onMuteToggle(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    if (this.dataset.muteButton !== 'true' || !this._getMuteToggle()) return;

    const videoElement = this._getPlayerElement();
    if (!videoElement) return;

    try {
      if (this.type === 'local') {
        videoElement.muted = !videoElement.muted;
      } else if (this.type === 'youtube') {
        const nextMuted = !Boolean(this._youtubeMutedState);
        this._youtubeMutedState = nextMuted;
        const fn = nextMuted ? 'mute' : 'unMute';
        videoElement.contentWindow?.postMessage(
          JSON.stringify({ event: 'command', func: fn, args: '' }),
          'https://www.youtube.com'
        );
      }
      this._syncMuteButtonState(videoElement);
    } catch (err) {
      console.error('Mute toggle error:', err);
    }
  }

  _playVideo(video){
    if (!video) return;

    try {
      if(this.type === 'local'){
        video.play().catch(err => console.warn('Video autoplay blocked:', err));
      } else if(this.type === 'youtube'){
        video.contentWindow?.postMessage('{"event":"command","func":"playVideo","args":""}', 'https://www.youtube.com');
      }
    } catch (err) {
      console.error('Play video error:', err);
    }
  }

  _pauseVideo(video) {
    if (!video) return;
    
    try {
      if (this.type === 'local') {
        video.pause();
      } else if (this.type === 'youtube') {
        video.contentWindow?.postMessage('{"event":"command","func":"pauseVideo","args":""}', 'https://www.youtube.com');
      }
    } catch (err) {
      console.error('Pause video error:', err);
    }
  }

  /**
   * Create the video html element
   */
  _buildVideo(){
    try {
      if (!this.videoURL) {
        return null;
      }

      const hasControls = this.dataset.controls === 'true';
      const isMuted = this.dataset.muted === 'true';
      const isLoop = this.dataset.loop === 'true';

      if(this.type === 'local'){
        const video = document.createElement('video');
        video.src = this.videoURL;
        video.autoplay = true;
        video.playsInline = true;
        if(hasControls) video.controls = true;
        if(isMuted) video.muted = true;
        if(isLoop) video.loop = true;
        return video;
      }

      if(this.type === 'youtube'){
        const videoID = this._getYoutubeVideoId(this.videoURL);
        if (!videoID) {
          return null;
        }
        const video = document.createElement("iframe");
        video.setAttribute("allowfullscreen", "");
        video.setAttribute("frameborder", "0");
        video.setAttribute("allow", "autoplay");
        video.setAttribute("src", `https://www.youtube.com/embed/${videoID}?rel=0&showinfo=0&autoplay=1&mute=${isMuted ? 1 : 0}&controls=${hasControls ? 1 : 0}&loop=${isLoop ? 1 : 0}&enablejsapi=1&origin=${window.origin}`);
        return video;
      }

      return null;
    } catch (err) {
      return null;
    }
  }

  /**
   * Pause video on scroll when out of viewport
   */
  pauseOnVisibilityChange(videoEle){
    if (!videoEle) return;
    
    this.scrollObserver = Utility.Observer.onChange(
      videoEle,
      null,  // onEnter - no action needed
      (video) => {  // onExit - pause video
        if(!video || video.contentWindow == null){
          this.scrollObserver?.disconnect();
          return;
        }
        this._pauseVideo(video);
      }
    );
  }

  /**
   * Poster Video Autoplay
   */
  managePosterVideos(){
    const posterVideo = Utility.DomSelector.$('[data-poster-video]', this);
    if(!posterVideo) return;

    Utility.Observer.once(posterVideo, (video) => {
      try {
        if (!video.dataset.src) return;
        const sourceTag = document.createElement('source');
        sourceTag.src = video.dataset.src;
        sourceTag.type = "video/mp4";
        video.appendChild(sourceTag);
        video.play().catch(err => console.warn('Poster video autoplay blocked:', err));
      } catch (err) {
        console.error('Poster video error:', err);
      }
    });
  }

  autoplayOnInit(element = this){
    Utility.Observer.once(element, (el, entry) => {
      if(entry.intersectionRatio > 0){
        el.toggleView();
      }
    });
  }

  /**
   * @param {boolean} muted
   */
  _setMuted(muted) {
    if (!this._ensureVideoSection()) return;

    const videoElement = this._getPlayerElement();
    if (!videoElement) return;

    try {
      if (this.type === 'local') {
        videoElement.muted = muted;
      } else if (this.type === 'youtube') {
        this._youtubeMutedState = muted;
        const fn = muted ? 'mute' : 'unMute';
        videoElement.contentWindow?.postMessage(
          JSON.stringify({ event: 'command', func: fn, args: '' }),
          'https://www.youtube.com'
        );
      }
      this._syncMuteButtonState(videoElement);
    } catch (err) {
      console.error('Set video mute error:', err);
    }
  }

  /**
   * Mute active custom-video when browser tab is hidden
   * @returns {boolean}
   */
  _muteForTabHidden() {
    if (!this.container?.classList.contains('playing--video')) return false;

    const videoElement = this._getPlayerElement();
    if (!videoElement) return false;

    const isMuted = this.type === 'local'
      ? videoElement.muted
      : Boolean(this._youtubeMutedState ?? this.dataset.muted === 'true');

    this._unmuteWhenTabVisible = !isMuted;
    if (this._unmuteWhenTabVisible) this._setMuted(true);

    return true;
  }

  /**
   * Restore audio after browser tab is visible again
   */
  _restoreAudioAfterTabVisible() {
    if (!this._unmuteWhenTabVisible) {
      this._unmuteWhenTabVisible = false;
      return;
    }

    this._setMuted(false);
    this._unmuteWhenTabVisible = false;
  }

  /**
   * Pause/mute plain video elements; mute custom-video hosts when tab is hidden
   */
  static _handleTabHidden() {
    const activeHost = Array.from(document.querySelectorAll('custom-video')).find((host) =>
      host.closest('.custom-video-container')?.classList.contains('playing--video')
    );

    if (activeHost?._muteForTabHidden()) {
      CustomVideo._tabActiveHost = activeHost;
      return;
    }

    const activeVideo = Array.from(document.querySelectorAll('video')).find((video) => {
      if (video.paused || video.readyState < 2) return false;

      const host = video.closest('custom-video');
      const section = host?.querySelector('.video-section');
      if (
        host?.closest('.custom-video-container')?.classList.contains('playing--video') &&
        section?.contains(video)
      ) {
        return false;
      }

      return true;
    });

    if (!activeVideo) return;

    CustomVideo._tabPlainVideo = activeVideo;
    CustomVideo._tabPlainVideoWasMuted = activeVideo.muted;
    activeVideo.pause();
    if (!activeVideo.muted) activeVideo.muted = true;
  }

  /**
   * Resume/unmute the video paused or muted when tab was hidden
   */
  static _handleTabVisible() {
    if (CustomVideo._tabActiveHost) {
      CustomVideo._tabActiveHost._restoreAudioAfterTabVisible();
      CustomVideo._tabActiveHost = null;
      return;
    }

    if (!CustomVideo._tabPlainVideo) return;

    const video = CustomVideo._tabPlainVideo;
    if (!CustomVideo._tabPlainVideoWasMuted) video.muted = false;

    video.play().catch((err) => {
      console.warn('Video resume blocked:', err);
    });

    CustomVideo._tabPlainVideo = null;
    CustomVideo._tabPlainVideoWasMuted = null;
  }

  static initTabVisibilityHandler() {
    if (CustomVideo._tabVisibilityBound) return;
    CustomVideo._tabVisibilityBound = true;

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        CustomVideo._handleTabHidden();
      } else {
        CustomVideo._handleTabVisible();
      }
    });
  }
}
customElements.define("custom-video", CustomVideo);
CustomVideo._activePopupHost = null;
CustomVideo._tabActiveHost = null;
CustomVideo._tabPlainVideo = null;
CustomVideo._tabPlainVideoWasMuted = null;
CustomVideo._tabVisibilityBound = false;
CustomVideo.initTabVisibilityHandler();

/**
* Modal Dialogue
*
*/
class ModalDialog extends HTMLElement {
  constructor() {
    super();

    this.isOpen = false;
    this.modal = Utility.DomSelector.$('.modal', this);
    this.modalOpeners = Utility.DomSelector.$$(`[data-modal-opener="${this.id}"]`);
    this.closeBtn = Utility.DomSelector.$('[id^="ModalClose-"]', this);

    this.setAttribute('aria-hidden', 'true');
    this.setAttribute('inert', '');
  }

  connectedCallback() {
    this.modalOpeners.forEach((opener)=>{
      opener.addEventListener('click', (evt)=>{
        evt.preventDefault();
        this.show(opener);
      });
    });

    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', this.hide.bind(this));
    }

    this.addEventListener('click', (evt) => {
      if (evt.target === this) this.hide();
    });
  }

  // Clean up event listeners
  disconnectedCallback() {
    this.isOpen = false;

    this.modalOpeners.forEach((opener) => {
      opener.removeEventListener('click', this.show.bind(this));
    });

    if (this.closeBtn) {
      this.closeBtn.removeEventListener('click', this.hide.bind(this));
    }

    this.removeEventListener('click', this.hide);
  }

  /**
   * Open the Modal
   * @param {element} opener 
   * @returns {ModalDialog} Returns this for method chaining
   */
  show(opener) {
    if (this.isOpen) return this; // Prevent opening if already open

    this.isOpen = true;
    this.openedBy = opener;
    Utility.CSS.add(this.modal, 'open');
    this.removeAttribute('inert');
    this.setAttribute('aria-hidden', 'false');

    SiteOverlay.showOverlay();
    
    // Announce modal opening with specific name
    const modalName = this.getAttribute('aria-label') || 'Modal Dialogue';
    Utility.announceToScreenReader(`${modalName} modal opened`);
    
    Utility.Focus.trap(this, this.closeBtn); // falls back to first focusable element if no close button

    return this; // Enable method chaining
  }

  /**
   * Close Modal Dialogue
   * @returns {ModalDialog} Returns this for method chaining
   */
  hide() {
    if (!this.isOpen) return this; // Prevent closing if already closed

    this.isOpen = false;
    Utility.CSS.remove(this.modal, 'open');
    this.setAttribute('inert', '');
    this.setAttribute('aria-hidden', 'true');

    SiteOverlay.hideOverlay();
    
    // Announce modal closing with specific name
    const modalName = this.getAttribute('aria-label') || 'Modal Dialogue';
    Utility.announceToScreenReader(`${modalName} modal closed`);
    
    Utility.Focus.release(this.openedBy);
    if(this.id == 'PopupModal-video') {
      const videoContainer = Utility.DomSelector.$('.video-container', this);
      if (videoContainer) videoContainer.innerHTML = '';

      const modalMuteWrap = Utility.DomSelector.$('[data-modal-video-mute-wrap]', this);
      if (modalMuteWrap) {
        Utility.CSS.remove(modalMuteWrap, 'is-active');
        modalMuteWrap.setAttribute('aria-hidden', 'true');
        modalMuteWrap.setAttribute('inert', '');
      }

      document.querySelectorAll('custom-video.placement--popup').forEach((videoHost) => {
        if (videoHost._suppressModalReset) return;
        videoHost._resetAfterModalClose();
      });
    }
    
    return this; // Enable method chaining
  }
}
customElements.define('modal-dialog', ModalDialog);

class CustomDrawer extends HTMLElement {
  constructor() {
      super();
      this.isOpen = false;

      this.openedBy = null;
      this.toggleDrawer = Utility.DomSelector.$$(`[data-toggleDrawer="${this.id}"], a[href="#${this.id}"]`);
      this.closeButtons = Utility.DomSelector.$$('[data-closedrawer]', this);
      const focusSelector = this.dataset.focusSelector;
      this.forceFocus = focusSelector
        ? Utility.DomSelector.$(focusSelector, this)
        : Utility.DomSelector.$('[data-closedrawer]', this);
      this.setAttribute('aria-hidden', 'true');
      this.setAttribute('inert', '');
  }

  connectedCallback() {
    this.bindEvents()
  }

  disconnectedCallback() {
    this.toggleDrawer.forEach(btn => btn.removeEventListener('click', this.openDrawer()));

    this.closeButtons.forEach(btn => btn.removeEventListener('click', this.closeDrawer.bind(this)));
    this.removeEventListener('focusout', this.focusOut.bind(this));
  }

  bindEvents(){
    this.toggleDrawer.forEach(btn => {
      btn.setAttribute('aria-expanded', false);
      btn.addEventListener('click', (evt) => {
        evt.preventDefault();
        (this.isOpen) ? this.closeDrawer(evt) : this.openDrawer(evt.currentTarget);
      });
    });

    this.closeButtons.forEach(btn => btn.addEventListener('click', this.closeDrawer.bind(this)));
    this.addEventListener('focusout', this.focusOut.bind(this));
  }

  /**
   * Focus Out Event to close drawer
   */
  focusOut(evt){
    if (!this.contains(evt.relatedTarget) && this.open) {
      this.closeDrawer();
    }
  }

  openDrawer(opener) {
    // Prevent opening if already open
    if (this.isOpen) return this;

    this.resetOtherDrawers();

    this.isOpen = true;
    this.openedBy = opener || null;
    Utility.CSS.add(this, 'open');
    this.removeAttribute('inert');
    this.setAttribute('aria-hidden', 'false');

    // Create drawer-specific overlay class from drawer ID
    const drawerClass = this.id || null;
    SiteOverlay.showOverlay(drawerClass);
    
    // Add below-header class to overlay if drawer has it
    const overlay = Utility.DomSelector.byId('site-overlay');
    if (overlay && this.classList.contains('below-header')) {
      Utility.CSS.add(overlay, 'below-header');
    }
    
    this.openedBy?.setAttribute('aria-expanded', true);
    Utility.Focus.trap(this, this.forceFocus); // falls back to first focusable element if no close button

    // Announce drawer opening to screen readers
    const drawerName = this.getAttribute('aria-label') || 'Drawer';
    Utility.announceToScreenReader(`${drawerName} drawer opened`);

    this._syncHeaderActionState();

    return this; // Enable method chaining
  }

  closeDrawer() {
      if (!this.isOpen) return this;

      Utility.CSS.remove(this, 'open');
      
      // Remove drawer-specific overlay class and below-header class
      const overlay = Utility.DomSelector.byId('site-overlay');
      if (overlay && this.id) {
        Utility.CSS.remove(overlay, this.id);
        Utility.CSS.remove(overlay, 'below-header');
      }
      
      SiteOverlay.hideOverlay();

      this.isOpen = false;
      this.setAttribute('inert', '');
      this.setAttribute('aria-hidden', 'true');
      this.hideOpenPanels();
      this.openedBy?.setAttribute('aria-expanded', false);
      Utility.Focus.release(this.openedBy);
      
      // Announce drawer closing to screen readers
      const drawerName = this.getAttribute('aria-label') || 'Drawer';
      Utility.announceToScreenReader(`${drawerName} drawer closed`);
      
      if(this.id == 'quickshop-drawer') {
        Utility.DomSelector.$('[data-quickshop-body]', this).innerHTML = '';
      }else if(this.id == 'header-search-layer') {
        const searchInput = this.querySelector('input[name="q"]');
        if(searchInput) {
          searchInput.value = '';
          searchInput.dispatchEvent(new Event('input'));
        }
      }
      this.openedBy = null;

      this._syncHeaderActionState();

      return this; // Enable method chaining
  }

  /**
   * Toggle the shared `header-action` class on the closest `.section-header`
   * via the Dropdown helper, so megamenu, predictive search and the search
   * drawer (`.open-searchform` / `[data-toggleDrawer="header-search-layer"]`)
   * all keep the header state in sync.
   */
  _syncHeaderActionState() {
    if (typeof Dropdown !== 'undefined' && typeof Dropdown.syncHeaderActionState === 'function') {
      Dropdown.syncHeaderActionState(this);
    }
  }

  resetOtherDrawers(){
    const openDrawers = Utility.DomSelector.$$('custom-drawer.open');
    openDrawers.forEach(drawer => {
      drawer.closeDrawer();
    });
    return this; // Enable method chaining
  }

  hideOpenPanels(){
    let openPanels = this.querySelectorAll('[is="collapsiblePanel"].open');
    openPanels.forEach(panel => panel.querySelector('[data-toggle="panel"]').click());

    let openDropdowns = Array.from(this.querySelectorAll('[is="drop-down"].open'));
    openDropdowns.forEach((ele) => {
      Utility.CSS.remove(ele, 'open');
      Utility.DomSelector.$('[data-toggle="open"]', ele)?.setAttribute('aria-expanded', false);
    });
    return this; // Enable method chaining
  }
}
customElements.define('custom-drawer', CustomDrawer);

// Single global Escape handler for all drawers, modals and dropdowns
document.addEventListener('keyup', (evt) => {
  if (!evt.code || evt.code.toUpperCase() !== 'ESCAPE') return;
  Utility.DomSelector.$$('custom-drawer.open').forEach(drawer => drawer.closeDrawer());
  Utility.DomSelector.$$('modal-dialog[aria-hidden="false"]').forEach(modal => modal.hide());
  Utility.DomSelector.$$('custom-select.open').forEach(select => select.closeDropdown());
});

/**
   * Manage Custom Notification Trigger
   *
   */
class ToastNotification extends HTMLElement {
  constructor() {
    super();

    this.container = Utility.DomSelector.$('.snotifyToast', this);
    this.closeBtn = Utility.DomSelector.$('.snotifyToast__close', this);
    this.animateNotifcation = null;

    // Set ARIA role for accessibility
    this.container.setAttribute('role', 'alert');
    this.setAttribute('aria-hidden', 'true');
    this.setAttribute('inert', '');
  }

  connectedCallback() {
    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.hide();
      });
    }
  }

  disconnectedCallback() {
    if (this.closeBtn) {
      this.closeBtn.removeEventListener('click', this.hide.bind(this));
    }
  }

  /**
   * Notification Type
   * @param {string} title 
   * @param {string} body 
   * @param {object} options 
   * @returns {ToastNotification} Returns this for method chaining
   */
  updateNotification(title, body, options){
    this.setAttribute('aria-hidden', 'false');
    this.removeAttribute('inert');

    Utility.CSS.add(this.container, 'open', `snotify-${options.type}`);
    Utility.DomSelector.$('.snotifyToast__title', this).textContent = title;
    Utility.DomSelector.$('.snotifyToast__body', this).textContent = body;

    this._manageToggle(options.timeout);
    
    return this; // Enable method chaining
  }

  /**
   * Duration of notification to hide again
   * @param timeout 
   */
  _manageToggle(timeout) {
    this.progressBar = Utility.DomSelector.$('[data-toast-pr]', this);
    const totalFrames = Math.ceil(timeout / 16.67) / 2;
    let frame =0; 
    let width = 0;

    this.animateNotifcation = () => {
      width = (frame / totalFrames) * 100;
      this.progressBar.setAttribute('style', `width: ${width}%`);
      if (frame < totalFrames) {
        frame++;
        requestAnimationFrame(this.animateNotifcation);
      } else {
        this.closeBtn.dispatchEvent(new Event('click'));
      }
    };
    requestAnimationFrame(this.animateNotifcation);
  }

  /**
   * Hide notification
   * @returns {ToastNotification} Returns this for method chaining
   */
  hide() {
    if (this.animateNotification) {
      cancelAnimationFrame(this.animateNotification);
    }
    this.setAttribute('aria-hidden', 'true');
    this.setAttribute('inert', '');

    this.container.className = 'snotifyToast';
    [Utility.DomSelector.$('.snotifyToast__title', this),Utility.DomSelector.$('.snotifyToast__body', this)].forEach(ele => ele.textContent = '');
    Utility.DomSelector.$("[data-toast-pr]", this).removeAttribute("style");

    return this; // Enable method chaining
  }
}
customElements.define("toast-notification", ToastNotification);
window.notificationEle = Utility.DomSelector.$('toast-notification');

//===============================================================================================================
//          Video Management Functions for Custom Video in Swiper Slides                                        //
//===============================================================================================================

/**
 * Handle slide video play/pause on slide change
 * @param {HTMLElement} slide 
 * @param {boolean} shouldPlay 
 */
const handleSlideVideo = (slide, shouldPlay) => {
  if (!slide) return;

  const videoHost = Utility.DomSelector.$('custom-video', slide);
  if (!videoHost) return;

  try {
    if (shouldPlay) {
      if (videoHost.videoStatus === 'empty') {
        videoHost.toggleView();
      } else {
        const media = videoHost._getPlayerElement();
        if (media) videoHost._playVideo(media);
      }
    } else if (videoHost.container?.classList.contains('playing--video')) {
      videoHost.hideContent();
    } else {
      const media = videoHost._getPlayerElement();
      if (media && videoHost.dataset.controls === 'true') {
        videoHost._pauseVideo(media);
      }
      videoHost._pausePosterVideo();
    }
  } catch (err) {
    console.error('Swiper slide video control error:', err);
  }
};

/**
 * Run autoplay on first active slide if autoplay is true and placement is grid
 * @param {HTMLElement} swiperEl 
 */
const runAutoplayIfActive = (swiperEl) => {
  if(!swiperEl || !swiperEl.querySelector('custom-video')) return;

  const firstActiveSlide = Utility.DomSelector.$('swiper-slide', swiperEl);
  if(!firstActiveSlide) return;

  const customVideo = firstActiveSlide.querySelector('custom-video');
  if(!customVideo) return;

  if(customVideo.dataset.autoplay === 'true' && customVideo.dataset.placement === 'grid') customVideo.autoplayOnInit(customVideo);
};

const HEADER_SLIDE_MOVE_ANIMATION = 'imageMove';

/**
 * Advance header slide-move slider when pan animation finishes (no post-animation hold)
 * @param {HTMLElement} swiperEl
 */
const initHeaderSlideMoveAutoplay = (swiperEl) => {
  if (
    swiperEl.dataset.globalHeaderSlider !== 'true' ||
    swiperEl.dataset.headerSlideAutoplay !== 'true' ||
    swiperEl.dataset.slideMoveBound === 'true'
  ) return;
  swiperEl.dataset.slideMoveBound = 'true';

  const getFallbackDelay = () => Number.parseInt(swiperEl.dataset.slideMoveDuration || '2970', 10);

  const advanceSlide = () => {
    if (swiperEl.dataset.slideMoveAdvancing === 'true') return;
    swiperEl.dataset.slideMoveAdvancing = 'true';
    window.clearTimeout(swiperEl._headerSlideMoveFallback);

    const swiper = swiperEl.swiper;
    if (swiper && !swiper.destroyed) {
      swiper.autoplay?.stop();
      swiper.slideNext();
    }

    window.requestAnimationFrame(() => {
      swiperEl.dataset.slideMoveAdvancing = 'false';
    });
  };

  const scheduleFallback = () => {
    window.clearTimeout(swiperEl._headerSlideMoveFallback);
    swiperEl._headerSlideMoveFallback = window.setTimeout(advanceSlide, getFallbackDelay());
  };

  const bindActiveSlideAnimation = () => {
    window.clearTimeout(swiperEl._headerSlideMoveFallback);

    const swiper = swiperEl.swiper;
    if (!swiper || swiper.destroyed) return;

    swiper.autoplay?.stop();

    const activeSlide = swiper.slides[swiper.activeIndex];
    if (!activeSlide) {
      scheduleFallback();
      return;
    }

    const targets = activeSlide.querySelectorAll(
      '.slider-media > picture img, .slider-media > svg, .slider-media .custom-video-container'
    );

    if (!targets.length) {
      scheduleFallback();
      return;
    }

    let handled = false;

    const onAnimationEnd = (event) => {
      if (handled || event.animationName !== HEADER_SLIDE_MOVE_ANIMATION) return;
      handled = true;
      targets.forEach((el) => el.removeEventListener('animationend', onAnimationEnd));
      advanceSlide();
    };

    targets.forEach((el) => {
      el.removeEventListener('animationend', onAnimationEnd);
      el.style.animation = 'none';
      void el.offsetWidth;
      el.style.removeProperty('animation');
      el.addEventListener('animationend', onAnimationEnd);
    });

    scheduleFallback();
  };

  const setup = () => bindActiveSlideAnimation();

  swiperEl.addEventListener('swiper:init', setup, { once: true });
  swiperEl.addEventListener('swiperslidechange', setup);

  if (swiperEl.swiper) setup();
};

const setupHeaderSlideMoveSliders = (context = document) => {
  Utility.DomSelector.$$(
    'swiper-container[data-global-header-slider="true"].slide-move[data-header-slide-autoplay="true"]',
    context
  ).forEach(initHeaderSlideMoveAutoplay);
};

/**
 * Bind video + slide handlers for swiper-container instances (once per element)
 * @param {Document|Element} context
 */
const manageSwiperSlides = (context = document) => {
  const swiperSliders = Utility.DomSelector.$$('swiper-container', context);
  if (!swiperSliders.length) return;

  swiperSliders.forEach((swiperEl) => {
    if (swiperEl.dataset.swiperSlidesManaged === 'true') return;
    swiperEl.dataset.swiperSlidesManaged = 'true';

    swiperEl.addEventListener('swiper:init', () => runAutoplayIfActive(swiperEl), { once: true });
    swiperEl.addEventListener('swiperslidechange', ({ detail }) => {
      const swiperInstance = detail && detail[0];
      if (!swiperInstance) return;

      const { activeIndex, previousIndex, slides } = swiperInstance;
      if (!slides || activeIndex == null || previousIndex == null) return;

      const prevSlide = slides[previousIndex];
      const activeSlide = slides[activeIndex];

      handleSlideVideo(prevSlide, false);
      handleSlideVideo(activeSlide, true);
    });
  });
};

const onShopifySectionLoad = (event) => {
  const root = event?.target;
  if (!root) return;
  manageSwiperSlides(root);
  setupHeaderSlideMoveSliders(root);
};

manageSwiperSlides();
setupHeaderSlideMoveSliders();

/**
 * Slider video block play button (blocks/slider-video-1.liquid)
 */
const handleSliderVideoPlay = (event) => {
  const button = event.target.closest('[data-slider-video-play]');
  if (!button) return;

  event.preventDefault();
  const block = button.closest('.slider-video-block');
  if (!block) return;

  const video = Utility.DomSelector.$('video', block);
  const iframe = Utility.DomSelector.$('iframe', block);

  try {
    if (video) {
      video.play().catch(err => console.warn('Slider video play blocked:', err));
      Utility.CSS.add(block, 'video-playing');
      return;
    }

    if (iframe) {
      iframe.contentWindow?.postMessage('{"event":"command","func":"playVideo","args":""}', 'https://www.youtube.com');
      Utility.CSS.add(block, 'video-playing');
    }
  } catch (err) {
    console.error('Slider video play error:', err);
  }
};

document.addEventListener('click', handleSliderVideoPlay);

// Wait for Swiper JS to load
customElements.whenDefined('swiper-container')
  .then(() => {
    console.log('Swiper JS is loaded!');
})
  .catch((error) => {
    console.error('Swiper failed to load:', error);
});

//===============================================================================================================
//          End of Video Management Functions for Custom Video and Swiper Slide Components                      //
//===============================================================================================================


//===============================================================================================================
//          Update Product Media Height Functions for Product Cards                                        //
//===============================================================================================================

(() => {
  const NAV_SELECTOR = '.custom-swiper-navigation';
  const TAB_TOGGLE_SELECTOR = '[data-toggle="tab"]';
  const TAB_PANEL_SELECTOR = '[data-tabpanel]';
  const TAB_CONTENT_CLASS = 'tabcontent';
  const DELAY = 50;
  const RESIZE_DELAY = 100;
  const MEASURE_PROPS = ['display', 'visibility', 'position', 'top', 'left', 'width', 'height', 'overflow', 'pointerEvents', 'zIndex'];

  const revealHiddenTabPanels = () => {
    const panels = [...document.querySelectorAll(`${TAB_PANEL_SELECTOR}:not(.open)`)];
    if (!panels.length) return () => {};

    const saved = panels.map((panel) => {
      const styles = {};
      MEASURE_PROPS.forEach((prop) => { styles[prop] = panel.style[prop]; });
      return { panel, styles };
    });

    panels.forEach((panel) => {
      panel.style.setProperty('display', 'block', 'important');
      panel.style.visibility = 'hidden';
      panel.style.position = 'absolute';
      panel.style.top = '0';
      panel.style.left = '0';
      panel.style.width = '100%';
      panel.style.height = 'auto';
      panel.style.overflow = 'hidden';
      panel.style.pointerEvents = 'none';
      panel.style.zIndex = '-1';
    });

    return () => {
      saved.forEach(({ panel, styles }) => {
        MEASURE_PROPS.forEach((prop) => {
          panel.style[prop] = styles[prop];
        });
      });
    };
  };

  const updateTabSwipers = () => {
    document.querySelectorAll(`${TAB_PANEL_SELECTOR} swiper-container`).forEach((swiperEl) => {
      swiperEl.swiper?.update();
    });
  };

  const measureProductHeights = () => {
    const cards = document.querySelectorAll('.card-product');
    if (cards.length === 0) return;

    const updates = [];
    for (let i = 0; i < cards.length; i++) {
      const card = cards[i];
      if (!card || card.offsetParent === null) continue;

      const media = card.querySelector('.product--media');
      if (!media) continue;

      const nav = card.closest('.swiper-wrapper__custom, section, .slider-wrapper')?.querySelector(NAV_SELECTOR);

      updates.push({
        card,
        height: media.offsetHeight,
        nav
      });
    }

    for (let i = 0; i < updates.length; i++) {
      const { card, height, nav } = updates[i];
      const heightStr = `${height}px`;

      card.style.setProperty('--product-media-height', heightStr);

      if (nav) {
        nav.style.setProperty('--product-media-height', heightStr);
        nav.style.setProperty('--nav-opacity', '1');
        nav.classList.add('arrow-center-image');
      }
    }
  };

  const updateHeights = () => {
    const restore = revealHiddenTabPanels();
    try {
      updateTabSwipers();
      measureProductHeights();
    } finally {
      restore();
    }
  };

  const initHiddenTabSliders = () => {
    const swiperEls = document.querySelectorAll(`${TAB_PANEL_SELECTOR} swiper-container`);
    if (!swiperEls.length) return;

    const waitForSwipers = [...swiperEls].map((el) => {
      if (el.swiper) return Promise.resolve();
      return new Promise((resolve) => {
        el.addEventListener('swiper:init', () => resolve(), { once: true });
        window.setTimeout(resolve, 3000);
      });
    });

    Promise.all(waitForSwipers).then(updateHeights);
  };

  const scheduleUpdate = (delay = 0) => window.setTimeout(updateHeights, delay);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateHeights, { once: true });
  } else {
    updateHeights();
  }

  window.addEventListener('load', () => {
    updateHeights();
    customElements.whenDefined('swiper-container').then(initHiddenTabSliders);
  });

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(updateHeights, RESIZE_DELAY);
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest(TAB_TOGGLE_SELECTOR)) scheduleUpdate(DELAY);
  });

  const observer = new MutationObserver((mutations) => {
    const shouldUpdate = mutations.some(({ target, attributeName }) => (
      ['aria-hidden', 'class'].includes(attributeName) &&
      target.classList?.contains(TAB_CONTENT_CLASS) &&
      target.classList.contains('open') &&
      target.getAttribute('aria-hidden') === 'false'
    ));

    if (shouldUpdate) scheduleUpdate(DELAY);
  });

  document.querySelectorAll(TAB_PANEL_SELECTOR).forEach((panel) => {
    observer.observe(panel, { attributes: true, attributeFilter: ['aria-hidden', 'class'] });
  });
})();

//===============================================================================================================
//          End of Update Product Media Height Functions for Product Cards                                        //
//===============================================================================================================


//===============================================================================================================
//          Update Buy Buttons Height (--act-btn-height) on Product Cards                                       //
//===============================================================================================================

(() => {
  const CARD_SELECTOR = '.card-product';
  const BUTTON_SELECTOR = '.product_buy_buttons .btn';
  const TAB_TOGGLE_SELECTOR = '[data-toggle="tab"]';
  const TAB_PANEL_SELECTOR = '[data-tabpanel]';
  const TAB_CONTENT_CLASS = 'tabcontent';
  const DELAY = 50;
  const RESIZE_DELAY = 100;

  const updateButtonHeights = () => {
    const cards = document.querySelectorAll(CARD_SELECTOR);
    if (cards.length === 0) return;

    // Batch read phase: measure each card's tallest buy button
    // Reading offsetHeight forces layout, so we collect all reads first
    const updates = [];
    for (let i = 0; i < cards.length; i++) {
      const card = cards[i];
      if (!card || card.offsetParent === null) continue;

      const buttons = card.querySelectorAll(BUTTON_SELECTOR);
      if (buttons.length === 0) continue;

      let tallest = 0;
      for (let j = 0; j < buttons.length; j++) {
        const h = buttons[j].offsetHeight;
        if (h > tallest) tallest = h;
      }
      if (tallest === 0) continue;

      updates.push({ card, height: tallest });
    }

    // Batch write phase: apply all CSS variable changes together
    for (let i = 0; i < updates.length; i++) {
      const { card, height } = updates[i];
      card.style.setProperty('--act-btn-height', `${height}px`);
    }
  };

  const scheduleUpdate = (delay = 0) => window.setTimeout(updateButtonHeights, delay);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateButtonHeights, { once: true });
  } else {
    updateButtonHeights();
  }

  window.addEventListener('load', updateButtonHeights);

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(updateButtonHeights, RESIZE_DELAY);
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest(TAB_TOGGLE_SELECTOR)) scheduleUpdate(DELAY);
  });

  const observer = new MutationObserver((mutations) => {
    const shouldUpdate = mutations.some(({ target, attributeName }) => (
      ['aria-hidden', 'class'].includes(attributeName) &&
      target.classList?.contains(TAB_CONTENT_CLASS) &&
      target.classList.contains('open') &&
      target.getAttribute('aria-hidden') === 'false'
    ));

    if (shouldUpdate) scheduleUpdate(DELAY);
  });

  document.querySelectorAll(TAB_PANEL_SELECTOR).forEach((panel) => {
    observer.observe(panel, { attributes: true, attributeFilter: ['aria-hidden', 'class'] });
  });
})();

//===============================================================================================================
//          End of Update Buy Buttons Height (--act-btn-height) on Product Cards                                //
//===============================================================================================================


// Dropdown outside-click handler → moved to dropdown.js

//===============================================================================================================
//          Header and Announcement Bar Height Calculator                                                       //
//===============================================================================================================


function setHeaderTopbarCSSVars() {
  const root = document.documentElement;
  const header = document.querySelector('.section-header');
  const topbar = document.querySelector('.topbar');
  
  if (header) {
    const headerHeight = header.offsetHeight;
    root.style.setProperty('--header-height', headerHeight + 'px');
  }
  if (topbar) {
    const topbarHeight = topbar.offsetHeight;
    root.style.setProperty('--announcement-bar-height', topbarHeight + 'px');
  }
}
setHeaderTopbarCSSVars();
window.addEventListener('resize', setHeaderTopbarCSSVars);


//===============================================================================================================
//          End of Header and Announcement Bar Height Calculator                                               //
//===============================================================================================================


//===============================================================================================================
//          Review Stars                                                                                        //
//===============================================================================================================

const ReviewStars = (() => {
  const STAR_PATH = 'M6.99991 11.5672L3.27667 13.9285C3.16726 13.9852 3.06572 14.0082 2.97204 13.9974C2.87905 13.9859 2.78844 13.9522 2.70023 13.8962C2.61134 13.8387 2.54433 13.7576 2.4992 13.6527C2.45407 13.5479 2.44997 13.4333 2.48689 13.3091L3.4777 8.8817L0.200634 5.89779C0.108322 5.81879 0.0474649 5.72436 0.0180618 5.61448C-0.0113412 5.5046 -0.00484512 5.3994 0.0375499 5.29886C0.079945 5.19831 0.136358 5.11573 0.206788 5.05109C0.277903 4.98862 0.373634 4.94624 0.493981 4.92398L4.81828 4.52756L6.50451 0.335016C6.551 0.216522 6.61802 0.131062 6.70554 0.0786372C6.79307 0.0262124 6.89119 0 6.99991 0C7.10864 0 7.2071 0.0262124 7.29531 0.0786372C7.38352 0.131062 7.45019 0.216522 7.49532 0.335016L9.18155 4.52756L13.5048 4.92398C13.6259 4.94553 13.7219 4.98826 13.793 5.05217C13.8642 5.11537 13.9209 5.1976 13.9633 5.29886C14.005 5.3994 14.0112 5.5046 13.9818 5.61448C13.9524 5.72436 13.8915 5.81879 13.7992 5.89779L10.5221 8.8817L11.5129 13.3091C11.5512 13.4319 11.5475 13.5461 11.5017 13.6516C11.4558 13.7572 11.3885 13.8384 11.2996 13.8951C11.2121 13.9525 11.1215 13.9866 11.0278 13.9974C10.9348 14.0082 10.8336 13.9852 10.7242 13.9285L6.99991 11.5672Z';
  const NS = 'http://www.w3.org/2000/svg';

  function parseRating(rawRating) {
    if (!rawRating || rawRating === 'null' || rawRating === '') return 0;

    try {
      const parsed = JSON.parse(rawRating);
      if (parsed === null || parsed === undefined) return 0;

      const val = typeof parsed === 'object' && parsed !== null
        ? parsed.value
        : parsed;

      const rating = parseFloat(val);
      return Number.isFinite(rating) && rating > 0 ? rating : 0;
    } catch (_) {
      // Liquid may output a non-JSON object string like "5.0 / Shop App"
      // Only accept if the entire trimmed string is a valid number
      const trimmed = rawRating.trim();
      if (!/^-?\d+(\.\d+)?$/.test(trimmed)) return 0;

      const direct = parseFloat(trimmed);
      return Number.isFinite(direct) && direct > 0 ? direct : 0;
    }
  }

  function makeStar(activeColor, inactiveColor, size, fillPercent, gradientId) {
    const svg = document.createElementNS(NS, 'svg');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    svg.setAttribute('width', size);
    svg.setAttribute('height', size);
    svg.setAttribute('viewBox', '0 0 14 14');
    svg.setAttribute('fill', 'none');
    svg.classList.add('review-star__icon');

    const defs = document.createElementNS(NS, 'defs');
    const gradient = document.createElementNS(NS, 'linearGradient');
    gradient.setAttribute('id', gradientId);
    gradient.setAttribute('x1', '0%');
    gradient.setAttribute('y1', '0%');
    gradient.setAttribute('x2', '100%');
    gradient.setAttribute('y2', '0%');

    const stop1 = document.createElementNS(NS, 'stop');
    stop1.setAttribute('offset', Math.min(fillPercent, 100).toFixed(2) + '%');
    stop1.setAttribute('stop-color', activeColor);

    const stop2 = document.createElementNS(NS, 'stop');
    stop2.setAttribute('offset', Math.min(fillPercent, 100).toFixed(2) + '%');
    stop2.setAttribute('stop-color', inactiveColor);

    gradient.appendChild(stop1);
    gradient.appendChild(stop2);
    defs.appendChild(gradient);
    svg.appendChild(defs);

    const path = document.createElementNS(NS, 'path');
    path.setAttribute('d', STAR_PATH);
    path.setAttribute('fill', 'url(#' + gradientId + ')');
    svg.appendChild(path);

    return svg;
  }

  function render(container) {
    if (!container || container.dataset.reviewStarsRendered) return;

    const rawRating     = container.dataset.rating || '';
    const activeColor   = container.dataset.activeColor || '#17457A';
    const inactiveColor = container.dataset.inactiveColor || '#D5D5D5';
    const size          = parseInt(container.dataset.starSize, 10) || 14;
    const noReviewLabel = container.dataset.noReviewLabel || 'No Review';
    const suffix        = (container.dataset.reviewSuffix || '').trim();

    container.dataset.reviewStarsRendered = 'true';

    const rating = parseRating(rawRating);

    if (rating <= 0) {
      const msg = document.createElement('span');
      msg.className = 'review-rating__empty fs-sm';
      msg.textContent = noReviewLabel;
      container.appendChild(msg);
      return;
    }

    const uid = (container.id || 'rs') + '-' + Math.random().toString(36).slice(2, 9);
    const wrap = document.createElement('div');
    wrap.className = 'd-flex align-items-center review-rating__stars gap-2';
    wrap.setAttribute('role', 'img');
    wrap.setAttribute('aria-label', rating.toFixed(1) + ' out of 5 stars');

    for (let i = 1; i <= 5; i++) {
      let fillPercent = 0;
      if (rating >= i) {
        fillPercent = 100;
      } else if (rating > i - 1) {
        fillPercent = (rating - (i - 1)) * 100;
      }
      wrap.appendChild(makeStar(activeColor, inactiveColor, size, fillPercent, uid + '-s' + i));
    }

    container.appendChild(wrap);

    
      const label = document.createElement('span');
      label.className = 'review-rating__label ls-base lh-1 px-6';
      if(suffix) {
        label.textContent = rating.toFixed(1) + ' ' + suffix;
      } else {
        label.textContent = rating.toFixed(1);
      }
      container.appendChild(label);
    
  }

  function init(scope = document) {
    if (!scope || typeof scope.querySelectorAll !== 'function') return;
    scope.querySelectorAll('[data-review-stars]:not([data-review-stars-rendered])').forEach(render);
  }

  return { init, render };
})();

ReviewStars.init();


//===============================================================================================================
//          End of Review Stars                                                                                 //
//===============================================================================================================

(function initProductCardWishlist() {
  const initializeWishlistButtons = (swat) => {
    if (!swat?.initializeActionButtons) return;
    swat.initializeActionButtons('.card-product .swym-add-to-wishlist-view-product');
  };

  globalThis.SwymCallbacks = globalThis.SwymCallbacks || [];
  globalThis.SwymCallbacks.push(initializeWishlistButtons);

  if (globalThis._swat) {
    initializeWishlistButtons(globalThis._swat);
  }

  document.addEventListener('DOMContentLoaded', () => {
    if (globalThis._swat) {
      initializeWishlistButtons(globalThis._swat);
    }
  });
})();
